enum ThemeFonts {
  Main = 'main',
}

export default ThemeFonts;
